import { render, staticRenderFns } from "./PostPermissions.vue?vue&type=template&id=2f231ea0&scoped=true"
import script from "./PostPermissions.vue?vue&type=script&lang=js"
export * from "./PostPermissions.vue?vue&type=script&lang=js"
import style0 from "./PostPermissions.vue?vue&type=style&index=0&id=2f231ea0&prod&lang=less&scoped=true"
import style1 from "./PostPermissions.vue?vue&type=style&index=1&id=2f231ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f231ea0",
  null
  
)

export default component.exports